import { render, staticRenderFns } from "./partner-audit-modal.vue?vue&type=template&id=5c8c1c9b&scoped=true&"
import script from "./partner-audit-modal.vue?vue&type=script&lang=js&"
export * from "./partner-audit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c1c9b",
  null
  
)

export default component.exports